<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App',
    data: function() {
      return {}
    },
    mounted: function() {},
    methods: {}
  }
</script>

<style>
  body,
  html {
    overflow: hidden;
    position: relative;
  }

  #app {
    height: 100%;
    overflow-y: auto;
    padding: 0;
    margin: 0;
    color: #000;
  }



  #app .el-table__header-wrapper th {
    background-color: #FFAC5A;
    text-align: center;
    color: #fff;
    font-weight: 100;
  }

  #app .el-table .cell {
    text-align: center;
  }

  #app .el-pager li.active {
    background-color: #FFAC5A;
    color: #fff;
    border-radius: 4px;
    padding: 0;
    min-width: 28px;
  }

  #app .el-table__empty-text {
    text-align: center;
  }

  #app .el-table::before {
    display: none;
  }
</style>

<style>
  .video-js .vjs-big-play-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .switchDiv {
    cursor: pointer;
    font-size: 1rem;
  }

  .switchDiv .el-switch__core {
    width: 140px !important;
    height: 30px;
    border-radius: 30px;
  }

  .switchDiv .el-switch__core:after {
    width: 70px;
    height: 26px;
    border-radius: 26px;
    background: #FFA44A;
  }

  .switchDiv:after {
    position: absolute;
    width: 50%;
    text-align: center;
    display: inline-block;
    z-index: 10;
    color: #000;
    content: attr(data-val2);
    right: 0;
  }

  .switchDiv:before {
    position: absolute;
    width: 50%;
    text-align: center;
    display: inline-block;
    z-index: 10;
    color: #fff;
    content: attr(data-val1);
    left: 0;
  }

  .switchDiv.is-checked:after {
    color: #fff;
  }

  .switchDiv.is-checked:before {
    color: #000;
  }

  .switchDiv.is-checked .el-switch__core:after {
    margin-left: -70px!important;
  }

  /*  color: #fff;
    width: 60px;
    height: 26px;
    border-radius: 26px;
    position: absolute;
    top: -2px;
    left: 1px;
    background: #FFA44A;
    text-align: center;
    margin-left:0px;
    transition: all .3s;
    line-height: 26px; */
  /*  .switchDiv::before{
    color: #000;
    content: attr(data-val2);
    position: absolute;
    z-index: 2;
    right: 0;
    margin: 0 1rem;
  }
  .switchDiv.is-checked:before{
    content: attr(data-val1);
    left: 0;
  } */
</style>



// WEBPACK FOOTER //
// src/App.vue